import { render } from "./SmallLink.vue?vue&type=template&id=592ba163"
import script from "./SmallLink.vue?vue&type=script&lang=js"
export * from "./SmallLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__